<template>
  <div
    class="map-legend bg-white bg-opacity-90 p-3 mb-3 rounded-md shadow-sm inline-block"
  >
    <div class="text-sm font-medium mb-1">
      Median {{ salaryPeriodLabel }} Salary
    </div>
    <div class="flex items-center space-x-1">
      <div
        class="w-4 h-4 rounded-sm"
        :style="{ backgroundColor: minColor }"
      />
      <span class="text-xs">{{ formatCurrency(minSalary) }}</span>
      <div
        class="w-12 h-4 rounded-sm"
        :style="{ background: gradientStyle }"
      />
      <div
        class="w-4 h-4 rounded-sm"
        :style="{ backgroundColor: maxColor }"
      />
      <span class="text-xs">{{ formatCurrency(maxSalary) }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { formatCurrency } from '~/utils/formatters'
import { useGlobalSalaryPeriod } from '~/composables/useGlobalSalaryPeriod'

const props = defineProps({
  minSalary: {
    type: Number,
    required: true
  },
  maxSalary: {
    type: Number,
    required: true
  }
})
const { activePeriod, displayPeriods } = useGlobalSalaryPeriod()
const salaryPeriodLabel = computed(() => {
  return displayPeriods[activePeriod.value].toLowerCase()
})
const minColor = '#E0E7FF'
const maxColor = '#4F46E5'
const gradientStyle = `linear-gradient(to right, ${minColor}, ${maxColor})`
</script>
